import { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useQuery } from "react-query";
import { Link } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import styled from "styled-components";
import { isPropertySignature } from "typescript";
import { fetchCoins } from "../api";
import { isDarkAtom } from "../atoms";
import { darkTheme } from "../theme";


const Container = styled.div`
  padding:0px 20px;
  max-width: 480px;
  margin: 0 auto;
`;

const Header = styled.header`
  height : 10vh;
  display:flex;
  justify-content:center;
  align-items:center;
`;

const CoinsList = styled.ul``;

const Coin = styled.li`
  background-color:${props => props.theme.cardBgColor};
  color:${(props) => props.theme.textColor};
  border-radius:15px;
  margin-bottom:10px;
  border: 1px solid white;
  a{
    align-items:center;
    display:flex;
    padding:20px; //밖에 있던 padding을 안으로 가져오는것만으로도 카드 전체에서 링크를 클릭할 수 있게 됨
    transition: color 0.2s ease-in;
  }
  &:hover{
    a{
      color:${(props) => props.theme.accentColor};
    }
  }
`;

const Title = styled.h1`
font-size:40px;
  color:${props => props.theme.accentColor};
`

const Loader = styled.span`
  text-align:center;
  display:block;
`

const Img = styled.img`
  width: 35px;
  height : 35px;
  margin-right:10px;
`;

const Toggle = styled.button`
  background-color:rgba(0, 0, 0, 0.5);
  width:50px;
  height:50px;
  border-radius:20px;
  font-size: 10px;
  color: ${props => props.theme.textColor};
  &:hover{
    color:${(props) => props.theme.accentColor};
  }

`

interface ICoin{
  id: string;
  name: string;
  symbol: string;
  rank: number;
  is_new: boolean;
  is_active: boolean;
  type: string;
}

interface ICoinsProps{
}

function Coins({ }: ICoinsProps) {
  const setDarkAtom = useSetRecoilState(isDarkAtom);
  const toggleDarkAtom = () => setDarkAtom(prev=>!prev);
  const { isLoading, data } = useQuery<ICoin[]>("allCoins", fetchCoins)

  return (
    <Container>
      <Helmet>
        <title>
          코인
        </title>
      </Helmet>
      <Header>
        <Title>코인</Title>
        <Toggle onClick={toggleDarkAtom}>
          Toggle
        </Toggle>
      </Header>
      {isLoading ? (
        <Loader>Loading...</Loader>
        ) : (< CoinsList >
        {data?.slice(0,100).map((coin) => (
          <Coin key={coin.id}>
            <Link to={{
              pathname: `/${coin.id}`,
              state:{name:coin.name},
            }}>
              <Img src={`https://cryptoicon-api.vercel.app/api/icon/${coin.symbol.toLowerCase()}`}
              />
              {coin.name} &rarr;
            </Link>
          </Coin>
        ))}
      </CoinsList>
      )}
    </Container>
  )
}
export default Coins;
